import axios from 'axios'
import {
  SigningDigestRequest,
  SigningDigestResponse,
  SignedDeclarationRequest,
  SignedDeclarationResponse,
} from '../models/types'

const apiUrl = process.env.REACT_APP_API_URL

const apiConfig = {
  xmlSigning: {
    baseUrl: `${apiUrl}/v3/xml-signing`,
  },
  audit: {
    baseUrl: `${apiUrl}/v3/transit-operation-audit`,
  },
}

export async function fetchSigningDigestV3(request: SigningDigestRequest) {
  const { data } = await axios.post<SigningDigestResponse>(
    `${apiConfig.xmlSigning.baseUrl}/signing-digests`,
    request,
  )
  return data
}

export async function submitSignedDeclarationV3(request: SignedDeclarationRequest) {
  const { data } = await axios.post<SignedDeclarationResponse>(
    `${apiConfig.audit.baseUrl}/signed-customs-submission`,
    request,
  )
  return data
}
